import { StylesObject } from '../../types/styles'
import { SITE_VARIABLES, mq } from '../../themes/variables'

export interface StoryLinkStylesObject extends StylesObject {
    root: StylesObject
    headerWrapper: StylesObject
    header: StylesObject
    arrow: StylesObject
    arrowLeftTop: StylesObject
    arrowLeftBottom: StylesObject
    arrowRightTop: StylesObject
    arrowRightBottom: StylesObject
}

export const getDefaultStylesObj = (
    theme: string,
    siteVars: typeof SITE_VARIABLES,
    preview: boolean | undefined,
): StoryLinkStylesObject => {
    let colorA = siteVars.COLORS.DARK
    let colorB = siteVars.COLORS.LIGHT

    if (theme === 'light') {
        colorA = siteVars.COLORS.GRAY
        colorB = siteVars.COLORS.DARK
    }

    const arrowDefault = {
        display: 'block',
        flexShrink: '0',
        width: '10px',
        height: '150px',
    }

    return {
        root: {
            position: 'relative',
            display: 'block',
            overflow: 'hidden',
            margin: '1em 0',
            textAlign: 'center',
            borderRadius: '100rem 0 0 100rem',
            textDecoration: 'none',
            [siteVars.CSS_SELECTORS.HOVER]: {
                opacity: '0.9',
            },
        },
        headerWrapper: {
            fontFamily: siteVars.TEXT_FONT_FAMILY.DEFAULT,
            fontWeight: '800',
            lineHeight: '1.1',
            marginRight: '22px',
            padding: '1rem 2rem',
            color: theme === 'dark' ? '#fff' : colorB,
            borderRadius: '0 28px 28px 0',
            backgroundColor: colorA,
            [siteVars.CSS_SELECTORS.HOVER]: {
                backgroundColor: theme === 'light' ? siteVars.COLORS.LIGHT : '',
            },
            ...(!preview && {
                [mq[2]]: {
                    fontSize: '1.2rem',
                    padding: '1.5rem 4rem',
                },
            }),
        },
        header: {
            textTransform: 'uppercase',
        },
        arrow: {
            position: 'absolute',
            top: '0',
            right: '0',
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            marginRight: '20px',
            [siteVars.CSS_SELECTORS.BEFORE]: {
                marginTop: '-30px',
                transform: 'translate(-20px) rotate(-35deg)',
            },
            [siteVars.CSS_SELECTORS.AFTER]: {
                marginTop: '-18px',
                transform: 'translate(-20px) rotate(35deg)',
            },
        },
        arrowLeftTop: {
            ...arrowDefault,
            marginTop: '32px',
            transform: 'translateX(-5px) translateY(-50%) rotate(-35deg)',
            backgroundColor: siteVars.COLORS.LIGHTWHITE,
        },
        arrowLeftBottom: {
            ...arrowDefault,
            marginTop: '-33px',
            transform: 'translateX(-14px) translateY(50%) rotate(35deg)',
            backgroundColor: siteVars.COLORS.LIGHTWHITE,
        },
        arrowRightTop: {
            ...arrowDefault,
            backgroundColor: '#dfdfdf',
            marginTop: '32px',
            transform: 'translateX(-13px) translateY(-50%) rotate(-35deg)',
        },
        arrowRightBottom: {
            ...arrowDefault,
            backgroundColor: '#dfdfdf',
            marginTop: '-33px',
            transform: 'translateX(-22px) translateY(50%) rotate(35deg)',
        },
    }
}
